import axios from 'axios';
import authHeader from './auth.header';

const adminApi = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://player.ukpl.co.uk' : 'http://localhost',
  headers: { 'Content-Type': 'application/json' },
});

function headers() {
  return { headers: authHeader() };
}

class BookingService {
  clearBookings() {
    return adminApi.delete('cpps/rest/admin/booking/clear', headers());
  }
}

export default new BookingService();
